import { Component, Input } from '@angular/core';
import { NavController, NavParams, PopoverController, ModalController } from 'ionic-angular';
import { PostPage } from '../post/post';
import { NewPostPage } from '../new-post/new-post';
import { SearchPage } from '../search/search';
import { ProfilePage } from '../profile/profile';
import { PostProvider } from '../../../providers/post/post'
import { AuthProvider } from '../../../providers/auth/auth';
import { LikeProvider } from '../../../providers/like/like';
import { TimeInterval, Subscription } from 'rxjs';
import { interval } from 'rxjs/observable/interval';
import { CommentProvider } from '../../../providers/comment/comment';
import { AvatarProvider } from '../../../providers/avatar/avatar';
import { CommonProvider } from '../../../providers/common';
import { PostPopoverComponent } from '../../../components/post-popover/post-popover';
import { ImageViewerModal } from '../../../components/image-viewer/image-viewer.component';
import { WellBeingProvider } from '../../../providers/wellbeing/wellbeing';
import {CupertinoPane} from "cupertino-pane";



@Component({
  selector: 'page-feed',
  templateUrl: 'feed.html',
})

export class FeedPage {

  @Input()
  isClubFeed: boolean;
  @Input()
  clubId: string;
  @Input()
  focusOnPostId: string = null; // If !null, loadPost will put this post id at first.

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public commonProvider: CommonProvider,
    public postProvider: PostProvider,
    public modalCtrl: ModalController,
    private authProvider: AuthProvider,
    private likeProvider: LikeProvider,
    private commentProvider: CommentProvider,
    public avatarProvider: AvatarProvider,
    public wellBeingProvider: WellBeingProvider) {

  }

  commentSection;

  // Well being
  displayWellBeing = false;

  postList: any;
  postListOnRefresh: any; // Used to check weither a new post has been posted or not.
  postListRefreshed: any;
  currUserId: string = this.authProvider.user.user_id

  //status
  loading: boolean = true;

  // Conditional rendering
  showComments: any = []; // Will store a post id and a boolean, if true, show all comments of that postid

  // Storing liked post for conditional rendering
  likedPosts: any = [];
  likedIds: any = [];
  // Storing liked comment for conditional rendering
  likedComment: any = [];
  likedCommentIds: any = [];
  //---
  needRefresh: boolean = false;
  userAvatar: string = '';

  //Commentaire
  redactingComment: any = [];

  //Regex
  urlRegex: RegExp = /(\b(https?|http):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;
  linksParse(text) { // Converts links to hypertext links.
    return text.replace(this.urlRegex, function (url) {
      return '<a target="_blank" href="' + url + '">' + url + '</a>';
    });
  }

  // Data fetching
  ngOnInit() {
    this.refreshByType();
    // Logged user avatar
    if (this.authProvider.user.avatar_id !== null) {
      this.avatarProvider.get(this.authProvider.user.avatar_id).subscribe((res) => {
        const avatar = res.data.avatar_content
        this.avatarProvider.avatarContent = avatar;
        this.userAvatar = avatar;
      })
    }
    this.loadDatas();
  }

  loadDatas(){
    this.wellBeingProvider.shouldFill().subscribe((res) => {
      if(res.success){
        this.displayWellBeing = res.data;
      }
    })
  }

  doRefresh(refresher) {
    this.refreshByType();
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }


  // LoadPost for general feed.
  loadPost() {
    // Posts
    this.postProvider.getAll().subscribe(
      res => {
        if (res.success) {
          this.postList = res.data
          this.postListRefreshed = this.postList; // Storing response before modifications
          // Check which post user liked
          this.likedPosts = [];
          this.likedIds = [];
          this.likedComment = [];
          this.likedCommentIds = [];
          // And stores them in arrays so front can render blue on thumbs etc...
          // Also used to delete a like, if a like exist on a specific post, clicking on
          // Like again will delete the like, we can do it because we store those infos bellow.
          this.postList.forEach((post, index) => {

            // Check if this post needs to be focused on
            if(this.focusOnPostId != null && post.id == this.focusOnPostId){
              this.postList.splice(index, 1);
              this.postList.unshift(post);
            }

            // Render link preview, if an url is present, generates the div
            if (post.url_metadatas !== null) {
              let metadatasJSON = JSON.parse(post.url_metadatas);
                post.content +=
                  '<a target="_blank" class="link-preview-href" href="' + metadatasJSON.url + '"><div class="link-preview">'
                  + '<img src="' + metadatasJSON.image + '"/>'
                  + '<h1>' + metadatasJSON.title + '</h1>'
                  + '<p>' + metadatasJSON.description + '</p>'
                  + '</div></a>';
            }


            post.Likes.forEach(likes => {
              if (likes.user_id == this.authProvider.user.user_id) {
                this.likedPosts.push(post.id)
                this.likedIds[post.id] = likes.id;
              }
            });

            post.Comments.forEach(comments => {
              comments.Likes.forEach(likes => {
                if (likes.user_id == this.authProvider.user.user_id) {
                  this.likedComment.push(comments.id)
                  this.likedCommentIds[comments.id] = likes.id;
                }
              });
            });
          });
          this.postProvider.refreshStatus(false);
          this.loading = false;
        } else { }

      }
    )
  }

  // LoadPost for club feed only
  loadClubPost() {
    // Posts
    this.postProvider.getAllClub(this.clubId).subscribe(
      res => {
        if (res.success) {
          this.postList = res.data
          this.postListRefreshed = this.postList; // Storing response before modifications
          // Check which post user liked
          this.likedPosts = [];
          this.likedIds = [];
          this.likedComment = [];
          this.likedCommentIds = [];
          // And stores them in arrays so front can render blue on thumbs etc...
          // Also used to delete a like, if a like exist on a specific post, clicking on
          // Like again will delete the like, we can do it because we store those infos bellow.
          this.postList.forEach((post, index) => {

            // Check if this post needs to be focused on
            if(this.focusOnPostId != null && post.id == this.focusOnPostId){
              this.postList.splice(index, 1);
              this.postList.unshift(post);
            }

            // Render link preview, if an url is present, generates the div
            if (post.url_metadatas !== null) {
              let metadatasJSON = JSON.parse(post.url_metadatas);
                post.content +=
                  '<a target="_blank" class="link-preview-href" href="' + metadatasJSON.url + '"><div class="link-preview">'
                  + '<img src="' + metadatasJSON.image + '"/>'
                  + '<h1>' + metadatasJSON.title + '</h1>'
                  + '<p>' + metadatasJSON.description + '</p>'
                  + '</div></a>';
            }

            post.Likes.forEach(likes => {
              if (likes.user_id == this.authProvider.user.user_id) {
                this.likedPosts.push(post.id)
                this.likedIds[post.id] = likes.id;
              }
            });

            post.Comments.forEach(comments => {
              comments.Likes.forEach(likes => {
                if (likes.user_id == this.authProvider.user.user_id) {
                  this.likedComment.push(comments.id)
                  this.likedCommentIds[comments.id] = likes.id;
                }
              });
            });

          });
          this.postProvider.refreshStatus(false)
          this.loading = false;
        } else { }

      }
    )
  }

  // Post interactions
  likePost(postId, postIndex) { // We are updating the objects front-side to avoid having to refresh the whole feed.
    // If user already liked that post, delete the like
    if (this.likedPosts.includes(postId)) {
      this.likeProvider.delete(this.likedIds[postId]).subscribe((res) => {
        if (res.success) {
          this.likedPosts.splice(this.likedPosts.indexOf(postId), 1);
          this.postList[postIndex].Likes.pop();
        }
      })
    } else {
      this.postProvider.doLike(postId).subscribe((res) => {
        if (res.success) {
          this.likedPosts.push(postId);
          this.postList[postIndex].Likes.push({env: 'front'})
        }
      })

    }
  }

  deletePost(postId) {
    this.postProvider.delete(postId).subscribe((res) => {
      if (res.success) {
        this.refreshByType();;
      }
    })
  }

  likeComment(commentId) {
    // If user already liked that post, delete the like
    if (this.likedComment.includes(commentId)) {
      this.likeProvider.delete(this.likedCommentIds[commentId]).subscribe((res) => {
        if (res.success) {
          this.refreshByType();
        }
      })
    } else {
      this.commentProvider.doLike(commentId).subscribe((res) => {
        if (res.success) {
          this.likedComment.push(commentId);
        }
      })
    }
  }

  submitComment(postId, postIndex) {
    if (typeof this.redactingComment[postId] === 'undefined' || this.redactingComment[postId] === ''){
      return ;
    }

    // TODO : Image upload;
    const comment = {
      image: '',
      content: this.redactingComment[postId].replace(/<[^>]*>/g, '')
    }

    this.commentProvider.create(postId, comment).subscribe((res) => {
      if (res.success) {
        this.redactingComment[postId] = '';
        this.postList[postIndex].Comments.push({
          content: comment.content,
          User: {
                avatar_content: {data: this.userAvatar, type: "Buffer"},
                first_name: "Vous à l'instant",
                last_name: ""
              },
          Likes: []
          })
      }
    })
  }

  deleteComment(commentId) {
    this.commentProvider.delete(commentId).subscribe((res) => {
      if (res.success) {
        this.refreshByType()
      }
    })
  }

  refreshByType(){
    this.isClubFeed == false ? this.loadPost() : this.loadClubPost();
  }


  // Routing

  fullScreenImg(image_content) {
    let modal = this.modalCtrl.create(ImageViewerModal, { imageContent: image_content });
    modal.present().then(() => {});
  }

  goToPost(postId) {
    this.navCtrl.push(PostPage, {
      postId: postId
    })
      .then(() => {
      });
  }

  newPost() {
    let modal = this.modalCtrl.create(NewPostPage);
    modal.onDidDismiss(() => {
      this.refreshByType();
    });
    modal.present().then(() => {});
  }

  goToSearch() {
    this.navCtrl.push(SearchPage, {})
      .then(() => {
      })
  }

  goToProfile(userId) {

    if(this.commentSection) {
      this.commentSection.hide();

      setTimeout(() => {
        this.commentSection.destroy()
      }, 200);
    }

    this.modalCtrl.create(ProfilePage, {userId : userId}).present().then(() => {});
  }

  // Post tooltip
  showPostTooltip(id, author){
    let popover = this.popoverCtrl.create(PostPopoverComponent, {post_id : id, canDelete: this.currUserId == author ? true : false})
    popover.onDidDismiss(() => {
      this.refreshByType();
    })
    popover.present();

  }

  // Well being
  setWellBeing(value){
    console.log(value)
    this.wellBeingProvider.saveReport(value).subscribe((res) => {
      if(res.success){
        this.displayWellBeing = false;
      }
    })
  }


  openComments(i: number) {
    this.commentSection = new CupertinoPane(
      '.cupertino-pane-' + i.toString(), // Pane container selector
      {
        parentElement: 'body', // Parent container
        breaks: {
          middle: { enabled: true, height: 1000, bounce: true },
        },
        bottomClose: true,
        buttonDestroy: false,
        backdrop: true,
        backdropOpacity: 0.8,
        onBackdropTap: () => {
          this.commentSection.hide();

          setTimeout(() => {
            this.commentSection.destroy()
          }, 200);
        },
      }
    );
    this.commentSection.present({animate: true});
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/feed/feed.component.ts